import React, { FunctionComponent } from 'react';
import TaxiImage from '../../shared/assets/images/video-cover-taxi.png';
import PhoneImage from '../../shared/assets/images/video-cover-phone.png';
import ProfileImage from '../../shared/assets/images/video-cover-profile.png';
import IssuesImage from '../../shared/assets/images/video-cover-issues.png';
import PlayIcon from '../icons/PlayIcon';
import Typography from '../typography/Typography';
import './videoCard.scss';
import TimeStamp from '../timeStamp/TimeStamp';

type VideoCardType = {
  title: string;
  duration: number;
  cover: 'taxi' | 'phone' | 'profile' | 'issues';
  onCardClick: () => void;
  className?: string;
  alt?: string;
}

const VideoCard: FunctionComponent<VideoCardType> = ({
  title,
  duration,
  cover,
  onCardClick,
  alt = 'Video cover',
  className = '',
}) => {
  const renderImage = () => {
    if (cover === 'taxi') return TaxiImage;
    if (cover === 'phone') return PhoneImage;
    if (cover === 'issues') return IssuesImage;
    return ProfileImage;
  };

  const image = renderImage();

  return (
    <div
      className={`video-card ${className}`}
      data-testid="instructional-video-card"
      onClick={onCardClick}
    >
      <div className="cover-wrapper">
        <div className="image-wrapper">
          <img src={image} alt={alt} />
        </div>
        <PlayIcon
          width={80}
          color="blue5"
          className="play-button-icon"
        />
        <TimeStamp className="duration" timeInSeconds={duration} showSeconds />
      </div>
      <div className="title-wrapper p-16">
        <Typography
          variant="h6"
          color="dark"
        >
          {title}
        </Typography>
      </div>
    </div>
  );
};

export default VideoCard;
